import { render, staticRenderFns } from "./kidsAcademy.vue?vue&type=template&id=ea0f729c&"
import script from "./kidsAcademy.vue?vue&type=script&lang=js&"
export * from "./kidsAcademy.vue?vue&type=script&lang=js&"
import style0 from "./kidsAcademy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports